import { PropsWithChildren } from "react";

import { LanguageProvider } from "./LanguageContext";
import ScreenSizeContextProvider from "./ScreenSizeContext";

export const ContextProviders: React.FC<PropsWithChildren> = ({ children }) => (
  <LanguageProvider>
    <ScreenSizeContextProvider>{children}</ScreenSizeContextProvider>
  </LanguageProvider>
);
